import React from 'react'
import { Keyboard, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { ImageAsset } from '@/types/common'
import { Button, FormScrollView } from '@/components/base'
import { FormInput } from '@/components/form-control'
import { IdCard } from '@/components/icon'
import { ImageButton } from '@/components/ImageButton'

export function KYCFormSection({
  control,
  handleNextStep,
  handleViewAddImage,
  images,
  readyForSubmission
}: {
  control: any
  handleNextStep: () => void
  handleViewAddImage: (index: number) => void
  images: ImageAsset[]
  readyForSubmission: boolean
}) {
  const { t } = useTranslation()
  const next = () => {
    Keyboard.dismiss()
    handleNextStep()
  }

  const viewImage = (index: number) => {
    Keyboard.dismiss()
    handleViewAddImage(index)
  }

  return (
    <View className={'flex-1'}>
      <FormScrollView className={'flex-1'} contentContainerStyle={{ flexGrow: 1 }}>
        <View className={'grow gap-2 p-4'}>
          <FormInput
            control={control}
            name={'country'}
            label={t('kyc:countryOrRegion')}
            type={'text'}
            autoCorrect={false}
            returnKeyType={'done'}
            maxLength={100}
          />
          <FormInput
            control={control}
            name={'lastname'}
            label={t('kyc:familyName')}
            type={'text'}
            autoCorrect={false}
            returnKeyType={'done'}
            maxLength={30}
          />
          <FormInput
            control={control}
            name={'firstname'}
            label={t('kyc:givenName')}
            type={'text'}
            autoCorrect={false}
            returnKeyType={'done'}
            maxLength={30}
          />
          <FormInput
            control={control}
            name={'governmentId'}
            label={t('kyc:identityNumber')}
            type={'text'}
            autoCorrect={false}
            returnKeyType={'done'}
          />
          <View>
            <Text className={'text-sm font-medium text-text-secondary'}>{t('kyc:identityPhotos')}</Text>
            <View className={'h-1'} />
            <View className={'flex-row gap-2'}>
              <ImageButton
                image={images[0]?.uri}
                onPress={() => viewImage(0)}
                blankElement={
                  <View className={'items-center gap-1'}>
                    <IdCard className={'size-6 text-text-quaternary'} />
                    <Text className={'text-xs text-text-secondary'}>{t('kyc:identityPhotoFront')}</Text>
                  </View>
                }
              />
              <ImageButton
                image={images[1]?.uri}
                onPress={() => viewImage(1)}
                blankElement={
                  <View className={'items-center gap-1'}>
                    <IdCard className={'size-6 text-text-quaternary'} />
                    <Text className={'text-xs text-text-secondary'}>{t('kyc:identityPhotoBack')}</Text>
                  </View>
                }
              />
            </View>
            <View className={'h-2'} />
            <Text className={'text-sm text-text-secondary'}>
              {t('kyc:identityPhotoHint')}
            </Text>
            <View className={'h-4'} />
          </View>
        </View>
      </FormScrollView>
      <View className={'border-t border-border-secondary bg-background-primary px-4 pt-3'}>
        <Button testID={'kyc-next-button'} size={'md'} onPress={next} disabled={!readyForSubmission}>
          {t('kyc:next')}
        </Button>
        <View className={'h-2'} />
      </View>
    </View>
  )
}
